module.exports = __webpack_public_path__ + "static/media/logo.defd9104.svg";